module.exports = "<div class=\"card-overflow col-12\">\r\n  <div class=\"card-front\">\r\n    <ng-content select=\"card-front\" ></ng-content>\r\n  </div>\r\n  <div class=\"card-revealed\" *ngIf=\"show\" [@socialsState]=\"socials\" >\r\n    <ng-content select=\"card-revealed\" ></ng-content>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/cards/card-reveal.component.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/cards/card-reveal.component.html
// module chunks = main